import { NavLink } from "react-router-dom";
import "../dashboard.css"
import Card from "../../../ui/card/Card";

import Card1 from "../../../ui/card/Card1";
import analytics from "../../../dashboardicon/Analytics.svg"
import ctm from "../../../dashboardicon/ControlTableManagement.svg"
import erm from "../../../dashboardicon/E-RollManagement.svg"
import um from "../../../dashboardicon/Usermanagement.svg"

function CommissionDashboard() {
    return (
        <div className="dashboard">
            <div className="card-container dashboard-container">
            <NavLink className="nav-link2" to="/com/usermanagement">
                        {/* <Card
                                card="dashboard-card bg-green"
                                h3="dashboard-head3"
                                icon="user-plus dashboard-icon"
                                header3="User Management"
                        /> */}
                        <Card1 icon={um} head="User Management" text="Create and manage users based on privilege provided"/>
                    </NavLink>
            </div>
        </div>
    );
  }
  
  export default CommissionDashboard;